<template>
  <button
    type="button"
    :class="[
      modelValue ? 'bg-primary' : 'bg-background-fg/50',
      'ring-offset-background disabled:bg-background-fg/20 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out disabled:pointer-events-none',
    ]"
    role="switch"
    aria-checked="false"
    :disabled="disabled"
    @click="emit('update:modelValue', !modelValue)"
  >
    <span
      aria-hidden="true"
      :class="[
        modelValue ? 'translate-x-5' : 'translate-x-0',
        'bg-background pointer-events-none inline-block h-5 w-5 transform rounded-full shadow ring-0 transition duration-200 ease-in-out',
      ]"
    />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()
</script>
